import validate from "D:/win_www/powerflow/powerflow-site/node_modules/.pnpm/nuxt@3.13.2_sass@1.81.0_typescript@5.7.2_vite@6.0.2/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45subdomain_45global from "D:/win_www/powerflow/powerflow-site/middleware/auth-subdomain.global.ts";
import fetch_45document_45global from "D:/win_www/powerflow/powerflow-site/middleware/fetchDocument.global.ts";
import set_45app_45global from "D:/win_www/powerflow/powerflow-site/middleware/setApp.global.ts";
import set_45theme_45global from "D:/win_www/powerflow/powerflow-site/middleware/setTheme.global.ts";
import manifest_45route_45rule from "D:/win_www/powerflow/powerflow-site/node_modules/.pnpm/nuxt@3.13.2_sass@1.81.0_typescript@5.7.2_vite@6.0.2/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  auth_45subdomain_45global,
  fetch_45document_45global,
  set_45app_45global,
  set_45theme_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "admin-page": () => import("D:/win_www/powerflow/powerflow-site/middleware/adminPage.ts"),
  auth: () => import("D:/win_www/powerflow/powerflow-site/node_modules/.pnpm/@sidebase+nuxt-auth@0.9.4_next-auth@4.21.1_typescript@5.7.2/node_modules/@sidebase/nuxt-auth/dist/runtime/middleware/auth.js")
}